import React from "react";
import ReactTimePicker from "rc-time-picker";
import moment from "moment";
import "rc-time-picker/assets/index.css";
import { useField } from "formik";

const TimePikcer = (props) => {
  const { disabled } = props;
  const [field, meta, helpers] = useField(props.name);
  const { name, value } = field;
  const { setValue } = helpers;

  return (
    <>
    <ReactTimePicker
      /*         defaultValue={value}
        value={value} */
     getPopupContainer={triggerNode => triggerNode.parentNode}
      disabled={disabled}
      value={moment(value, "HH:mm")}
      defaultValue={moment(value, "HH:mm")}
      showSecond={false}
      format='HH:mm'
      onChange={(v) => {
        if (v === null) {
          setValue("0000");
        } else {
          setValue(v.format("HHmm"));
        }
      }}
    />
    </>
  );
};

export default TimePikcer;
